// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3C0pl","rootSuccess":"CompleteLink_rootSuccess__2zFKy","rootFailure":"CompleteLink_rootFailure__noKSS","isDisabled":"CompleteLink_isDisabled__2AzxT"};